<template>
    <svg :width="size" :height="size" viewBox="8 6 24 24" xmlns="http://www.w3.org/2000/svg">
        <path v-if="overlayPathData" :d="overlayPathData" />
    </svg>
</template>
<script setup>
import { onMounted } from 'vue';
import { collectionPinProps, useCollectionPinComponent, usePinOverlayComponent } from '../../composables/useCollection';
import { CollectionType } from 'ihunter-common';

const props = defineProps({
    ...collectionPinProps(CollectionType.Waypoint),
});

const { size } = useCollectionPinComponent(props);
const { overlayPathData, initializeOverlayPathData } = usePinOverlayComponent(props);

onMounted(() => {
    initializeOverlayPathData();
});
</script>
